/* ============================================================
   BLOG INDEX — File: assets/blog-index.js
   ============================================================ */
(function () {
  function init(section) {
    const filter = section.querySelector('[data-mgx-filter]');
    const cards = Array.from(section.querySelectorAll('[data-mgx-card]'));
    if (!filter) return;
    const btns = Array.from(filter.querySelectorAll('.mgx-filter-btn'));

    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        const cat = btn.getAttribute('data-mgx-cat');
        btns.forEach(b => b.classList.toggle('is-active', b === btn));
        cards.forEach(card => {
          const show = cat === 'ALLE' || card.getAttribute('data-cat') === cat;
          card.hidden = !show;
        });
      });
    });
  }
  function initAll() { document.querySelectorAll('.mgx').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', (e) => {
    const s = e.target.querySelector('.mgx'); if (s) init(s);
  });
})();
